export default "__VITE_ASSET__C0Pt9FzI__"